import { getRecoil } from "recoil-nexus";
import { Swarm } from '@lbs/swarm-client';

import upperDataStore from "src/stores/upperData";
import { ISwarmConfig } from "src/constants/interfaces";
import { ISwarmBetshopCommand } from "./models/request";

export const authorizeSwarmCommand = <TRequest>(request: TRequest) => {
  const { authData } = getRecoil(upperDataStore);
  return { ...request, token: authData.token };
};

export const createBetshopCommand = <TRequest>(request: TRequest, name: string): ISwarmBetshopCommand<TRequest> => ({
  name,
  params: request,
});

export const initSwarm = (language: string, swarmConfig: ISwarmConfig) => {
  const { authData } = getRecoil(upperDataStore);
  const [{ url: swarmUrl }] = swarmConfig.websocket;

  const swarmSessionParams = {
    language,
    site_id: authData?.pid,
    terminal: authData?.tid,
  };

  return Swarm.init(swarmUrl, swarmSessionParams, swarmConfig);
};